<title>{{ ndcOfferManagementCapabilitiesPage.htmlTitle }}</title>
<app-banner [banner]="ndcOfferManagementCapabilitiesPage.banner" [isCommonBanner]="true"
  [isDefaultPageBanner]="false"></app-banner>

<div class="container mt-3">
  <h5>
    <span style="color: #2980b9">
      <a [href]="OfferManagementLink"> {{ OfferManagementTitle }} </a> {{ linkTextSeperator }} <a
        [href]="OrderManagementLink"> {{ OrderManagementTitle }} </a>
    </span>
  </h5>
  <!-- Nav tabs -->
  <div class="mt-20 managementTab mb-5">
    <ul class="nav nav-tabs">
      <li class="tab-link bgdgry" *ngFor="let link of tabMenu.links; let i = index" class="tab-link bgdgry"
        [ngClass]="selectedIndex === i ? 'border-blue' : 'border-darkblack'">
        <a class="nav-link" data-bs-toggle="tab" href="#{{ link.href }}" (click)="selectedIndex = i">
          <i [ngClass]="link.class || ''"></i>
          <span class="hideme"> {{ link.title }}</span></a>
      </li>
    </ul>

    <!-- Tab panes -->
    <div class="tab-content pb-5">
      <div *ngFor="let link of tabMenu.links; let linkIndex = index" class="tab-pane fade"
        [ngClass]="linkIndex === selectedIndex ? 'show active container' : 'container'" id="{{ link.href }}">
        <!-- <div id="{{ link.href }}" *ngFor="let link of tabMenu.links; let linkIndex = index"
        [ngClass]="linkIndex === 0 ? 'container tab-pane active' : 'container tab-pane'"> -->
        <br />
        <app-section [sections]="getNonAccordianSections(link.title)" [isNDCManagement]="true"> </app-section>

        <div class="managementAccordian"
          *ngFor="let section of getAccordianSections(link.title); let sectionIndex = index">
          <span class="lightBlue">
            <h4>{{ section.heading }}</h4>
          </span>
          <div class="accordion card"
            [ngClass]="toggleMap.get(collapsedStatusArray[sectionIndex]).sectionBorderTopClass">
            <div class="card-header active">
              <h4 (click)="toggleCollapsed(sectionIndex)" class="flex-text">
                <div [ngClass]="toggleMap.get(collapsedStatusArray[sectionIndex]).arrowIconsClass" class="arrow-icon">
                </div>
                <span [ngClass]="toggleMap.get(collapsedStatusArray[sectionIndex]).activeClass">{{ section.body
                  }}</span>
              </h4>
            </div>
            <div [ngClass]="toggleMap.get(collapsedStatusArray[sectionIndex]).accordionClass"
              class="collapsible card-body" [innerHTML]="section.subBody || '' | mdToHtml"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>